var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaiga({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.287568,43.9155813 L212.324664,128.115466 L128.124779,116.152563 L140.087683,31.9526775 L224.287568,43.9155813 L224.287568,43.9155813 Z",
    opacity: 0.8,
    fill: "#A295AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8853252,212.290983 L43.848229,128.091098 L128.048114,140.054002 L116.08521,224.253887 L31.8853252,212.290983 L31.8853252,212.290983 Z",
    opacity: 0.8,
    fill: "#5D6F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8482612,32.0645356 L128.048146,44.0274395 L116.085243,128.227325 L31.8853574,116.264421 L43.8482612,32.0645356 L43.8482612,32.0645356 Z",
    opacity: 0.8,
    fill: "#8CD592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.226084,224.263692 L128.026199,212.300788 L139.989103,128.100903 L224.188988,140.063807 L212.226084,224.263692 L212.226084,224.263692 Z",
    opacity: 0.8,
    fill: "#665E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.642193,255.595097 L68.562934,187.597737 L136.560294,136.518478 L187.639553,204.515838 L119.642193,255.595097 L119.642193,255.595097 Z",
    opacity: 0.8,
    fill: "#3C3647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.463211,136.38964 L187.465851,187.4689 L136.386592,119.47154 L204.383953,68.3922807 L255.463211,136.38964 L255.463211,136.38964 Z",
    opacity: 0.8,
    fill: "#837193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.436624,0.553850534 L187.515883,68.5512107 L119.518523,119.63047 L68.4392642,51.6331097 L136.436624,0.553850534 L136.436624,0.553850534 Z",
    opacity: 0.8,
    fill: "#A2F4AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.463311092,119.700163 L68.4606712,68.6209042 L119.53993,136.618264 L51.5425699,187.697523 L0.463311092,119.700163 L0.463311092,119.700163 Z",
    opacity: 0.8,
    fill: "#7EA685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.963225,95.7423436 L160.2954,128.074519 L127.963225,160.406694 L95.6310499,128.074519 L127.963225,95.7423436 L127.963225,95.7423436 Z",
    fill: "#3C3647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiga);
export default __webpack_public_path__ + "static/media/Taiga.89878cad62e5a1ad2828fc485d99c3a7.svg";
export { ForwardRef as ReactComponent };